// extracted by mini-css-extract-plugin
export default {"root":"ConfirmModal_root__RtQqp","container":"ConfirmModal_container__dB1rd","body":"ConfirmModal_body__B58Ql","footer":"ConfirmModal_footer__ukCzi"};